module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "upload-filelist"
  }, [_c('div', {
    staticClass: "header"
  }, [_c('div', {
    staticClass: "left"
  }, [_c('div', {
    staticClass: "icon"
  }, [_c('rt-icon', {
    attrs: {
      "name": "rt-base-orders_fill",
      "color": "#fff",
      "size": "24"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "title"
  }, [_vm._v("\n        " + _vm._s(_vm.title) + "\n      ")])]), _vm._v(" "), _c('el-upload', {
    ref: "upload",
    staticClass: "right",
    attrs: {
      "show-file-list": false,
      "on-success": _vm.handleSuccess,
      "before-upload": _vm.beforeUpload,
      "http-request": _vm.uploadFile,
      "file-list": _vm.fileList,
      "action": ""
    }
  }, [_c('rt-icon', {
    attrs: {
      "name": "rt-base-upload",
      "color": "#fff",
      "size": "18"
    }
  }), _vm._v(" "), _c('span', [_vm._v("上传文件")])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('el-table', {
    attrs: {
      "data": _vm.list,
      "stripe": "",
      "border": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": "文件名称",
      "sortable": "",
      "prop": "name",
      "width": "300"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(
          _vm.uploadFlag == true &&
          scope.row.uploadPercent > 0 &&
          scope.row.uploadPercent != 100
        ) ? _c('div', {
          staticClass: "progress-box"
        }, [_c('el-progress', {
          attrs: {
            "percentage": scope.row.uploadPercent,
            "show-text": false
          }
        }), _vm._v(" "), _c('p', {
          staticClass: "progress"
        }, [_vm._v("已上传" + _vm._s(scope.row.uploadPercent) + "%")])], 1) : _vm._e(), _vm._v(" "), (!scope.row.isEdit) ? _c('div', {
          staticClass: "noEdit"
        }, [_c('rt-icon', {
          attrs: {
            "name": _vm.iconName(scope.row.name),
            "color": _vm.iconColor(scope.row.name),
            "size": "21"
          }
        }), _vm._v(" "), _c('span', {
          staticClass: "name"
        }, [_vm._v(_vm._s(scope.row.name))])], 1) : _c('div', {
          staticClass: "cell-box"
        }, [_c('el-input', {
          attrs: {
            "placeholder": "请填写文件名称"
          },
          model: {
            value: (scope.row.name),
            callback: function($$v) {
              _vm.$set(scope.row, "name", $$v)
            },
            expression: "scope.row.name"
          }
        })], 1)]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "文件大小",
      "sortable": "",
      "prop": "size",
      "width": "120"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.size > 0) ? _c('p', [_vm._v(_vm._s(_vm.fileSize(scope.row.size)))]) : _vm._e()]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "标题",
      "sortable": "",
      "prop": "title"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(!scope.row.isEdit) ? _c('p', [_vm._v(_vm._s(scope.row.title))]) : _c('div', {
          staticClass: "cell-box"
        }, [_c('el-input', {
          attrs: {
            "placeholder": "请填写标题名称"
          },
          model: {
            value: (scope.row.title),
            callback: function($$v) {
              _vm.$set(scope.row, "title", $$v)
            },
            expression: "scope.row.title"
          }
        })], 1)]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "备注",
      "sortable": "",
      "prop": "remark"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(!scope.row.isEdit) ? _c('p', [_vm._v(_vm._s(scope.row.remark))]) : _c('div', {
          staticClass: "cell-box"
        }, [_c('el-input', {
          attrs: {
            "type": "textarea",
            "placeholder": "请填写备注"
          },
          model: {
            value: (scope.row.remark),
            callback: function($$v) {
              _vm.$set(scope.row, "remark", $$v)
            },
            expression: "scope.row.remark"
          }
        })], 1)]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "操作",
      "sortable": "",
      "prop": "operation",
      "align": "right",
      "min-width": "120"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('div', {
          staticClass: "operation"
        }, [_c('rt-list-button-group', [(!scope.row.isEdit) ? _c('rt-button', {
          attrs: {
            "text": "",
            "type": "plain"
          },
          on: {
            "click": function($event) {
              return _vm.edit(scope)
            }
          }
        }, [_vm._v("\n                编辑\n              ")]) : _c('rt-button', {
          attrs: {
            "text": "",
            "type": "plain"
          },
          on: {
            "click": function($event) {
              return _vm.save(scope)
            }
          }
        }, [_vm._v("\n                保存\n              ")]), _vm._v(" "), _c('rt-button', {
          attrs: {
            "text": "",
            "type": "plain"
          },
          on: {
            "click": function($event) {
              return _vm.reupload(scope.$index)
            }
          }
        }, [_vm._v("\n                重新上传\n              ")]), _vm._v(" "), _c('rt-popconfirm', {
          attrs: {
            "title": "确定需要删除这条内容吗？"
          },
          on: {
            "onConfirm": function($event) {
              return _vm.onConfirm(scope.row.name, scope.$index)
            }
          }
        }, [_c('rt-button', {
          attrs: {
            "slot": "reference",
            "text": "",
            "type": "plain"
          },
          slot: "reference"
        }, [_vm._v("\n                  删除\n                ")])], 1)], 1)], 1)]
      }
    }])
  })], 1)], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0c492798"}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/vue-xpc/src/components/uploadFilelist/rtUploadFilelist.vue
// module id = 1456
// module chunks = 72